import React, { useState } from "react";
import { Box, Typography, Grid, TextField, Button, Divider } from "@mui/material";

const getValue = (obj, path) =>
  path.split('.').reduce((acc, key) => (acc ? acc[key] : ''), obj);

const setValue = (obj, path, value) => {
  const keys = path.split('.');
  const lastKey = keys.pop();
  const nested = keys.reduce((acc, key) => {
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, obj);
  nested[lastKey] = value;
};

const ProfileForm = ({
  title,
  formData,
  setFormData,
  fields,
  isEditing,
  onSave,
  onToggleEdit,
  showSaveButton = true,
  isInterlocuteurTab = false,
  onChangePassword
}) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handlePasswordChange = () => {
    if (newPassword !== confirmPassword) {
      alert("Les mots de passe ne correspondent pas.");
      return;
    }

    const updatedFormData = { ...formData, newPassword: newPassword };
    setFormData(updatedFormData);

    onChangePassword(newPassword); 
  };

  const numericFields = ["utilisateur.phone", "ice", "tranche"];  
  const handleInputChange = (e, path) => {
    let value = e.target.value;

    if (numericFields.includes(path)) {
      value = value.replace(/[^0-9]/g, "");
    }

    const updatedFormData = { ...formData };
    setValue(updatedFormData, path, value);
    setFormData(updatedFormData);
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">{title}</Typography>
        <Button variant="outlined" onClick={onToggleEdit}>
          {isEditing ? "Annuler" : "Éditer"}
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />
      
      <Grid container spacing={2}>
        {fields.map(({ label, name, type = "text", multiline = false, rows = 2, readOnly = false, onKeyPress }) => (
          <Grid item xs={12} size={label === "Description" ? 12 : 6} key={name}>
            <TextField
              label={label}
              fullWidth
              type={type}
              multiline={multiline}
              rows={rows}
              value={getValue(formData, name) || ""}
              onChange={(e) => handleInputChange(e, name)}  
              onKeyPress={onKeyPress}
              variant="outlined"
              InputProps={{
                readOnly: readOnly || !isEditing || name === "utilisateur.email", 
              }}
            />
          </Grid>
        ))}
      </Grid>

      {isEditing && showSaveButton && (
        <Box mt={3} textAlign="right" display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={onSave}>
            Sauvegarder
          </Button>
        </Box>
      )}

      {isInterlocuteurTab && isEditing && (
        <Box mt={3}>
          <Typography variant="h6" fontWeight="bold">Changer le mot de passe</Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} size={6}  >
              <TextField
                label="Nouveau mot de passe"
                fullWidth
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} size={6}>
              <TextField
                label="Confirmer mot de passe"
                fullWidth
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Box mt={2} textAlign="right">
            <Button
              variant="contained"
              color="primary"
              onClick={handlePasswordChange}
            >
              Mettre à jour le mot de passe
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ProfileForm;
